import {
  FETCH_CONTENT_COLLECTION,
  FETCH_CONTENT_COLLECTION_FULFILLED,
  FETCH_CONTENT_COLLECTION_REJECTED,
} from 'b2b-apps/shop/content/redux/contentCollections/actionTypes';
import {
  ContentCollectionEntryType,
  FetchContentCollectionAction,
  FetchContentCollectionFulfilledAction,
  FetchContentCollectionRejectedAction,
} from 'b2b-apps/shop/content/redux/contentCollections/types';

const fetchContentCollection = (
  collectionId: string,
  filters: Record<string, any>,
): FetchContentCollectionAction => ({
  type: FETCH_CONTENT_COLLECTION,
  payload: {
    collectionId,
    filters,
  },
});

const fetchContentCollectionFulfilled = (
  collectionId: string,
  response: ContentCollectionEntryType[],
): FetchContentCollectionFulfilledAction => ({
  type: FETCH_CONTENT_COLLECTION_FULFILLED,
  payload: {
    collectionId,
    data: response,
  },
});

const fetchContentCollectionRejected = (
  collectionId: string,
  error: ErrorType,
): FetchContentCollectionRejectedAction => ({
  type: FETCH_CONTENT_COLLECTION_REJECTED,
  payload: {
    collectionId,
    error,
  },
});

export {
  fetchContentCollection,
  fetchContentCollectionFulfilled,
  fetchContentCollectionRejected,
};
